import React, { useState } from "react";
import Typography from "antd/es/typography/Typography";
import Select from "antd/es/select";
import Button from "antd/es/button";
import Row from "antd/es/grid/row";
import "./Recordings.less";
import { NotesDetailCard } from "../../../component";
import { CentreLogo } from "../../../assets/images";
import { useGetRecordingsQuery } from "../../../redux/services/class";
import { useSelector } from "react-redux";
import { CheckOutlined, StopOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { EmptyCard } from "../../../component";
import { useGetStudentBatchesQuery } from "../../../redux/services/batches";
const { Option } = Select;

const Title = Typography;
const Recordings = () => {
  const { student_id } = useSelector((state) => state.auth);
  const [selectedCoaching, setSelectedCoaching] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const { data: recordings, isLoading } = useGetRecordingsQuery({
    student_id: student_id,
  });
  const { data: batches, isLoading: batchLoading } =
    useGetStudentBatchesQuery(student_id);
  const coachingOptions = React.useMemo(() => {
    if (!batches?.data) return [];

    // Transform to options array using Object.entries
    return Object.entries(batches?.data).map(([id, name]) => ({
      value: name.coaching_name,
      label: name.coaching_name,
    }));
  }, [batches]);

  return (
    <div className='recording-notes-container'>
      <div className='classes-notes'>
        <Title className='title'>All Recordings</Title>
      </div>
      <div style={{ marginTop: "20px" }}>
        {/* Filter Section */}
        <div className='filter-section'>
          <Select
            placeholder='Coaching'
            style={{ width: 120, marginRight: "10px" }}
            onChange={(value) => setSelectedCoaching(value)}
            allowClear
            options={coachingOptions}
            loading={batchLoading}
          ></Select>
          <Select
            placeholder='Course'
            style={{ width: 120, marginRight: "10px" }}
            onChange={(value) => setSelectedCourse(value)}
            allowClear
          >
            <Option value='Chemistry'>Chemistry</Option>
            <Option value='Physics'>Physics</Option>
            <Option value='Math'>Math</Option>
          </Select>
          <Select
            placeholder='Subject'
            style={{ width: 120, marginRight: "10px" }}
            onChange={(value) => setSelectedSubject(value)}
            allowClear
          >
            <Option value='Inorganic'>Inorganic</Option>
            <Option value='Mechanics'>Mechanics</Option>
            <Option value='Algebra'>Algebra</Option>
          </Select>
          <Button type='primary' icon={<CheckOutlined />}>
            Apply
          </Button>
        </div>

        {/* Cards Section */}
        <Spin spinning={isLoading}>
          <Row gutter={[16, 16]}>
            {recordings?.data?.length ? (
              recordings?.data?.map((recording) => (
                <Row
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <NotesDetailCard
                    lectureId={recording.lecture_id}
                    lectureName={recording.lecture_name}
                    lectureNumber={recording.lectureNumber}
                    date={`${recording.date} || ${recording.time}`}
                    coachingLogo={recording.coachingLogo}
                    classUrl={recording.class_url}
                  />
                </Row>
              ))
            ) : (
              <EmptyCard text={recordings?.message || "No Recordings Found"} />
            )}
          </Row>
        </Spin>
      </div>
    </div>
  );
};

export default Recordings;
